<script setup>
import HomeRightSideTabs from "./HomeRightSideTabs.vue";
import { computed, defineAsyncComponent } from "vue";
import { useHomeTabsStore } from "@/stores/home/useHomeTabs.store";
import { storeToRefs } from "pinia";
import HomeGroups from "./HomeGroups.vue";

const HomeReportSummary = defineAsyncComponent(() =>
  import("./HomeReport.vue")
);

const HomeMyVideos = defineAsyncComponent(() =>
  import("@/components/new-home/my-videos/HomeMyVideos.vue")
);

const HomeEventsAndReminders = defineAsyncComponent(() =>
  import("@/components/new-home/events-and-reminders/HomeEventsAndReminders.vue")
);

const FeaturedVideo = defineAsyncComponent(() =>
  import("./HomeFeaturedVideo.vue")
);

const homeTabStore = useHomeTabsStore();
const { selectedRightSectionTab } = storeToRefs(homeTabStore);

const selectedComponent = computed(() => {
  if (selectedRightSectionTab.value === "report_summary") {
    return HomeReportSummary;
  }
  if (selectedRightSectionTab.value === "my_videos") {
    return HomeMyVideos;
  }
  return HomeEventsAndReminders;
});
</script>
<template>
  <div class="w-full h-full flex flex-col gap-2 lg:gap-5">
    <HomeRightSideTabs />
    <KeepAlive>
      <component :is="selectedComponent" />
    </KeepAlive>
    <div class="w-full border-t border-untitled-gray-300" />
    <FeaturedVideo />
    <div class="w-full border-t border-untitled-gray-300" />
    <div class="bg-white">
      <HomeGroups></HomeGroups>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
